import { Navigate, useLocation } from "react-router-dom";

export function LegacyIntegrationVendorRedirect({ slug }: { slug: string }) {
  const { search } = useLocation();
  return <Navigate replace to={`../vendor/${slug}${search}`} />;
}
